/**
 * Ensures a URL has a protocol prefix.
 * If the URL does not start with http:// or https://, prepends https://.
 */
export function ensureProtocol(url: string): string {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}
